import type { BillingCustomer } from '@common/types/billing';
import type { CustomerInfo } from './types';

function hasValue(value: unknown): boolean {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    return true;
}

function formatAddress(address?: BillingCustomer['address'] | null): string {
    if (!address) return '';

    const cityState = [address.city, address.state].filter(hasValue).join(', ');
    const postalCountry = [address.postal_code, address.country].filter(hasValue).join(' ');

    const parts = [address.line1, address.line2, cityState, postalCountry].filter(hasValue);

    return parts.map((part) => String(part)).join('\n');
}

export function buildInvoiceCustomer(
    billingCustomer?: BillingCustomer | null,
    fallbackCompany?: string,
): CustomerInfo | null {
    if (!billingCustomer) return null;

    const formattedAddress = formatAddress(billingCustomer.address);

    const customer: CustomerInfo = {
        name: billingCustomer.name ?? undefined,
        company: billingCustomer.name ?? fallbackCompany ?? undefined,
        address: formattedAddress || undefined,
        phone: billingCustomer.phone ?? undefined,
        email: billingCustomer.email ?? undefined,
    };

    const hasDetails = Object.values(customer).some((value) => hasValue(value));

    return hasDetails ? customer : null;
}
